// extracted by mini-css-extract-plugin
export var lightMode = "_p-0";